export const images = {
  logo: "https://cdn.magicpatterns.com/uploads/qrkynUkL3UHt3nSFYcegW1/flowkus-schreibakademie-eva-maria-bast-logo.desktop.webp.webp",
  hero: "https://cdn.magicpatterns.com/uploads/1FfRe4mBWezyiuU1XvokRZ/eva-maria-bast-buchcoaching-schreiben-notizbuch.desktop.webp.webp",
  writing: "https://cdn.magicpatterns.com/uploads/rKUB4KGVWbcnnhAfNpGuig/eva-maria-bast-bestseller-autorin-laptop-meer.desktop.webp.webp",
  about: "https://cdn.magicpatterns.com/uploads/k139SdAz4w4tTL6yzQr98E/eva-maria-bast-autorin-mit-buch-lachend.desktop.webp.webp",
  freedom: "https://cdn.magicpatterns.com/uploads/5dit28tB6UzxKrSSxrU5xV/eva-maria-bast-schreiben-von-ueberall.desktop.webp.webp",
  garden: "https://cdn.magicpatterns.com/uploads/u4MecqDVU387dBchozHvbs/eva-maria-bast-flowkus-methode-buch-unter-baum.desktop.webp.webp",
};

export const bookingUrl = "https://calendly.com/d/dz9d-56b-7m6/expertengesprach-team-eva-maria-bast";

export const ctas = {
  call: { label: "Kostenloses Erstgespräch", href: "#kontakt" },
  facebookPage: "/facebook-gruppe",
  facebook: {
    label: "Der Facebook-Gruppe beitreten",
    href: "https://www.facebook.com/groups/goldfunken.von.der.idee.zum.buch",
  },
};

export const socialLinks = [
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/evamariabast/" },
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/evamariabast/" },
  {
    id: "group",
    label: "Facebook-Gruppe „Goldfunken – Von der Idee zum Buch“",
    href: "https://www.facebook.com/groups/goldfunken.von.der.idee.zum.buch",
  },
] as const;

export const aboutStats = [
  { value: "8×", label: "SPIEGEL-Bestseller" },
  { value: "1 Mio.+", label: "verkaufte Exemplare" },
  { value: "100+", label: "Bände der „Geheimnis“-Reihe verlegt" },
];

export const nextSteps = [
  {
    id: "facebook",
    eyebrow: "Werde Teil der",
    title: "Facebook-Gruppe",
    text: "„Goldfunken – Von der Idee zum Buch“: eine Gemeinschaft für alle, die vom eigenen Buch träumen. Mit Impulsen zum Schreiben, Tipps rund um Plot und Figuren und Menschen, die Dich beim Dranbleiben bestärken.",
    cta: "Der Facebook-Gruppe beitreten",
    href: "/facebook-gruppe",
    tone: "light",
  },
  {
    id: "booking",
    eyebrow: "Buche Dein",
    title: "Erstgespräch",
    text: "Lerne mich in einem kostenlosen und unverbindlichen Gespräch kennen. Gemeinsam schauen wir, wo Du stehst und wie Dein persönlicher Weg zum fertigen Buch aussehen kann.",
    cta: "Kostenloses Erstgespräch",
    href: bookingUrl,
    tone: "dark",
  },
] as const;

export const navItems = [
  { label: "Methode", href: "#methode" },
  { label: "Programm", href: "#programm" },
  { label: "Über mich", href: "#ueber-mich" },
  { label: "Kontakt", href: "#kontakt" },
];

export const doubtQuotes = [
  "Du bist doch kein Schriftsteller.",
  "Du hattest in Deutsch doch immer eine Sechs.",
  "Vom Schreiben kann man nicht leben – lern lieber was Richtiges.",
  "Wer bist du denn, dass du ein Buch schreiben willst?",
];

export const obstacles = [
  "Du weißt nicht, wie Du anfangen sollst.",
  "Dir fehlt das Handwerkszeug für einen Roman.",
  "Im Alltag ist alles andere wichtiger als Dein Buch.",
  "Du bleibst nicht dran, sobald es schwierig wird.",
  "Dir fehlen die Kontakte zu Verlagen.",
  "Du hast Manuskripte verschickt – und nur Absagen erhalten.",
];

export const formula = [
  { label: "Talent", range: "10–20 %", share: 15 },
  { label: "Handwerkszeug", range: "10–20 %", share: 15 },
  { label: "Disziplin, Dranbleiben & Mindset", range: "der Rest", share: 70 },
];

export const journeySteps = [
  {
    title: "Den Asphalt aufbrechen",
    text: "Viele Menschen sind zugemauert – von Verletzungen, Zweifeln, alten Sätzen. Auf Asphalt wächst nichts. Also beginnen wir dort.",
  },
  {
    title: "Den Boden bereiten",
    text: "Gemeinsam bearbeiten wir Dein Schriftsteller-Mindset: der fruchtbare Grund, auf dem alles Weitere gedeihen kann.",
  },
  {
    title: "Die Saat ausbringen",
    text: "Spannungsbogen, Figurenaufbau, Plot, Treatment – das Handwerk, das aus einer Idee eine tragfähige Geschichte macht.",
  },
  {
    title: "Deine Geschichten blühen",
    text: "Aus der Saat werden Blumen: Dein fertiges, überarbeitetes Manuskript – und das Vertrauen, dass noch viele folgen.",
  },
];

export const programPillars = [
  {
    title: "Das Handwerkszeug",
    text: "Spannungsbogen, Figurenaufbau, Plot und Treatment – praxisnah und direkt an Deinem eigenen Manuskript angewendet.",
    short: "Spannungsbogen, Figuren, Plot – direkt an Deinem Manuskript.",
  },
  {
    title: "Das Schriftsteller-Mindset",
    text: "Dranbleiben, wenn es schwierig wird, Schreibblockaden überwinden – und in einem halben Jahr ein Buch schreiben und überarbeiten.",
    short: "Dranbleiben und Blockaden überwinden – ein Buch in sechs Monaten.",
  },
  {
    title: "Der Weg zum Verlag",
    text: "Wie man professionell an Verlage herantritt – mit meinem Netzwerk und Know-how.",
    short: "Professionell an Verlage herantreten – mit meinem Netzwerk und Know-how.",
  },
  {
    title: "Edition Goldfunken",
    text: "Unser hauseigener Verlag: Alle Teilnehmenden können ihr Buch hier veröffentlichen – damit Du es wirklich in den Händen hältst.",
    short: "Unser eigener Verlag: Dein Buch erscheint auf Wunsch hier.",
  },
];

export const roles = ["Bestseller-Autorin", "Journalistin", "Buchcoachin", "Verlegerin"];
